/*global translate*/
import React from 'react'
const { rxgetLocal } = global.rootRequire('classes/request')
const { rxaget ,changeColorSVG} = global.rootRequire('classes/ulti')
// const { checkNameUser } = global.rootRequire('classes/chat')
const CallRatingComponent = global.rootRequire('components/shares/call_rating/rxCallRating').default

global.isclient && require('./rxCall.css')

export const renderComponent = (vm) => {
  let group_id = vm.stoppedCallObj?.group_id || vm.callObj?.group_id || vm.rateObj.group_id || 0
  let call_id =  vm.stoppedCallObj?.call_id || vm.callObj?.call_id || vm.rateObj.call_id || 0

  return (<div>
    { vm.state.flagCalling && vm.renderZCall() }
    {/* { vm.state.open_call_rating &&
      <CallRatingComponent
        isOpen={true}
        group_id={group_id }
        call_id={call_id }
        score={0}
        func={(isOpen) => vm.openCallRating(isOpen)}
      />
    } */}
    
    {vm.state.showSaveRecording &&
      <div className='call-save-recording'>
        <div className='save-recording-container'>
          <div className='save-recording-title'>Recording Complete</div>
          <div className='save-recording-content'>Do you want to save the recorded video?</div>
          <div className='save-recording-format'>{vm.selectedMimeType && vm.selectedMimeType.includes('mp4') ? 'MP4 format' : 'Video format (MP4 not supported by your browser)'}</div>
          <div className='save-recording-buttons'>
            <button className='save-recording-button' onClick={e => vm.saveRecording()}>Save</button>
            <button className='save-recording-button' onClick={e => vm.discardRecording()}>Discard</button>
          </div>
        </div>
      </div>
    }
    
    {/*{vm.renderZCall()}*/}
  </div>)
}

export const renderZCall = (vm) => {
  let typeCall = rxaget(vm.callObj, 'media_type', 1)
  let remote_uin = rxaget(global.rxu.array(rxaget(vm.callObj, 'callee_uins', [])).filter(ele => (ele !== vm.userid.toString())), '0', '')
  let objUsers = vm.users
  if (!objUsers[remote_uin]) {
    let rxusers = rxgetLocal('rxusers')
    try { if (typeof(rxusers) !== 'undefined') { objUsers = JSON.parse(rxusers) } } catch(e) {}
  }
  // let uname = (objUsers[remote_uin]) ? checkNameUser(objUsers[remote_uin]) : ''
  let uname = (vm.calleeUser && vm.calleeUser.full_name) ? vm.calleeUser.full_name : (vm.calleeUser.phone)

  let flagMinimize = vm.state.flagMinimize
  
  return <div className={flagMinimize ? '' : 'zchat_callscreen'} onClick={e => vm.handleClickOutside(e)}>
    
    <div className={flagMinimize ? '' : 'zchat_callscreen_bg'}></div>

    {vm.state.ringtone && <audio controls autoPlay hidden loop>
      <source src='./sounds/soundcallmess.mp3' type='audio/mpeg' />
    </audio>}

    <div className={flagMinimize ? '' : 'zchat_callscreen_main'}>
      {!((typeCall === 2 || vm.state.flagCamera) && vm.state.flagStartCall) && <div className={flagMinimize ? 'zchat_callcenter_minimize 22' : 'zchat_callcenter 11'}>
        <img className='zchat_callbox_close' alt='' src={changeColorSVG('./images/default/icons/icon-close.png')} onClick={e => vm.onClickStopCall()}/>
        {(vm.state.flagStartCall && !flagMinimize) && <img className='zchat_callbox_minimize' alt='' src={changeColorSVG('./images/default/icons/icon-minimize.svg')} onClick={e => vm.onClickMinimizeCall()}/>}
        {(vm.state.flagStartCall && flagMinimize) && <img className='zchat_callbox_minimize' alt='' src={changeColorSVG('./images/default/icons/icon-maximize.svg')} onClick={e => vm.onClickMinimizeCall()}/>}
        {vm.state.flagStartCall && <div className='device-trouble-icon' onClick={(e) => vm.showCallTrouble()}><span className='icon-info'></span></div>}

        <div className='zchat_callbox'>
          <div className='zchat_callInfo'>

            <div className={flagMinimize ? 'zcall_container_minimize' : 'zcall_container'}>
              {(vm.calleeUser && vm.calleeUser.full_name ) && <div className={flagMinimize ? 'zcall_info_minimize' : 'zcall_info'}>
                {vm.calleeUser.full_name}
              </div>}
              {(!flagMinimize && vm.calleeUser && vm.calleeUser.phone && (vm.calleeUser.phone !== vm.calleeUser.full_name)) && <div className='zcall_content_desc'>
                {vm.calleeUser.phone}
              </div>}
              {!vm.state.flagStartCall && <div className='zcall_content'>
                {(vm.state.descAlertCall === 0) ? translate('Contacting...') : (vm.state.descAlertCall === 1) ? translate('Ringing') :  (vm.state.descAlertCall === 2) ? translate('Is Calling') : translate('Connecting') }
              </div>}
              {vm.state.flagStartCall && <div className='zcall_content'>
                {!vm.state.flagEnding && <div>{rxaget(vm.state.time, 'm', '00')}:{rxaget(vm.state.time, 's', '00')}</div>}
                {vm.state.flagEnding && <div>{translate('Call Ended')}</div>}
              </div>}

              {!flagMinimize && <div className='zcall_avatar'>
                <img className='zcall_avatarimg' src={`${global.rxu.config.cdn_endpoint}` + rxaget(vm.calleeUser, 'profile_url', '')} alt='profile_url' onError={(e)=>{e.target.onerror = null; e.target.src = './images/default/static/avadefault.svg'}} /> 
              </div>}

              <div className='zcall_buttons' id='zcall_buttons'>
                <div className='zcall_group_button'>
                  {vm.state.flagStartCall && <div className={flagMinimize ? 'zcall_button_minimize' : 'zcall_button'} onClick={e => vm.changeFlagMic()}>
                    <img className={flagMinimize ? 'zcall_btn_minimize zcall_btn_bg' : 'zcall_btn zcall_btn_bg'} alt='' src={changeColorSVG('./images/default/icons/mic_enable.svg')} style={(vm.state.flagMic) ? {display: 'block'} : {display: 'none'}} />
                    <img className={flagMinimize ? 'zcall_btn_minimize zcall_btn_border' : 'zcall_btn zcall_btn_border'} alt='' src={changeColorSVG('./images/default/icons/mic_disable.svg')} style={(vm.state.flagMic) ? {display: 'none'} : {display: 'block'}}/>
                  </div>}
                  {/*(vm.state.flagStartCall && typeCall === 1 && !flagMinimize) && <div className={flagMinimize ? 'zcall_button_minimize' : 'zcall_button'} onClick={e => vm.changeFlagCamera()}>
                    <img className={flagMinimize ? 'zcall_btn_minimize zcall_btn_border' : 'zcall_btn zcall_btn_border'} alt='' src={changeColorSVG('./images/default/icons/call_video_enable.svg')} style={(!vm.state.flagCamera) ? {display: 'block'} : {display: 'none'}}/>
                    <img className={flagMinimize ? 'zcall_btn_minimize zcall_btn_bg' : 'zcall_btn zcall_btn_bg'} alt='' src={changeColorSVG('./images/default/icons/call_video_disable.svg')} style={(vm.state.flagCamera) ? {display: 'block'} : {display: 'none'}} />
                  </div>*/}


                  <div className={flagMinimize ? 'zcall_button_minimize 44' : 'zcall_button 33'} >
                    <img className={flagMinimize ? 'zcall_cancel_minimize' : 'zcall_cancel'} alt='' src={changeColorSVG('./images/default/icons/cancelcall.png')} onClick={e => {
                      e.stopPropagation();
                      vm.onClickStopCall();
                    }} />
                  </div>
                  {(!vm.state.flagStartCall && !vm.isRoomCreator) && <div className={flagMinimize ? 'zcall_button_minimize' : 'zcall_button'} >
                    <img className='zcall_answer' alt='' src={changeColorSVG('./images/default/icons/acceptcall.png')} onClick={e => vm.acceptCall()} />
                  </div>}

                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className='device-setting-icon icon-settings' onClick={(e) => vm.showDeviceSetting()}></div>

        {vm.state.flagShowSetting && <div className='device-setting'>
          <img className='device-setting-close' alt='' src={changeColorSVG('./images/default/icons/icon-close.png')} onClick={e => vm.onClickCloseSetting()}/>
          <div className='device-setting-row'>
            <div className='device-setting-label'>Audio Input</div>
            <label className="device-select-box" >
              <select className='device-setting-select' value={vm.state.audioinputDefault} onChange={vm.changeDeviceAudioInput}>
                {vm.state.audioinput.map(deviceInfo => <option key={deviceInfo.value} value={deviceInfo.value}>{deviceInfo.text}</option>)}
              </select>
            </label>
          </div>
          <div className='device-setting-row'>
            <div className='device-setting-label'>Audio Output</div>
            
            <label className="device-select-box" >
              <select value={vm.state?.audiooutputDefault || ''} onChange={vm.changeDeviceAudioOutput}>
                {vm.state.audiooutput.map(deviceInfo => <option key={deviceInfo.value} value={deviceInfo.value}>{deviceInfo.text}</option>)}
              </select>
            </label>

          </div>
        </div>}

      </div>}

      <div className={flagMinimize ? 'zchat_videocallcenter_minimize' : 'zchat_videocallcenter'} style={((typeCall === 2 || vm.state.flagCamera) && vm.state.flagStartCall) ? {display: 'block'} : {display: 'none'}}>
        <div className='zchat_videocallinfo'>
          {(vm.state.flagStartCall && !flagMinimize) && <img className='zchat_callbox_minimize' alt='' src={changeColorSVG('./images/default/icons/icon-minimize.svg')} onClick={e => vm.onClickMinimizeCall()}/>}
          {/*{(vm.state.flagStartCall && flagMinimize) && <img className='zchat_callbox_minimize' alt='' src={changeColorSVG('./images/default/icons/icon-maximize.svg')} onClick={e => vm.onClickMinimizeCall()}/>}*/}
          {!flagMinimize && <div className='zcall_info'>{uname}</div>}
          {!flagMinimize && <div className='zcall_content'>
            {rxaget(vm.state.time, 'm', '00')}:{rxaget(vm.state.time, 's', '00')}
          </div>}
        </div>  

        <div className={flagMinimize ? 'zchat_videocallmain_minimize' : 'zchat_videocallmain'}>
          <div className='zchat_videocall_remote'>
            <video id="remote-video" autoPlay="autoplay"></video>
            <audio id="remote-audio" autoPlay></audio>
          </div>

          <div className='zchat_videocall_local'>
            <video id="local-video" autoPlay="autoplay" muted="muted" style={flagMinimize ? {display: 'none'} : {display: 'block'}}></video>
            <audio id="local-audio" autoPlay muted="muted"></audio>
          </div>
        </div>

        {flagMinimize && <img className='zchat_callbox_maximize' alt='' src={changeColorSVG('./images/default/icons/icon-maximize.svg')} onClick={e => vm.onClickMinimizeCall()}/>}
        {flagMinimize && <img className='zchat_callbox_close' alt='' src={changeColorSVG('./images/default/icons/icon-close.png')} onClick={e => {
          e.stopPropagation();
          vm.onClickStopCall();
        }}/>}
        {vm.state.flagStartCall && <div className='device-trouble-icon' onClick={(e) => vm.showCallTrouble()}><span className='icon-info'></span></div>}


        {!flagMinimize && <div className='zcall_buttons' id='zcall_buttons'>
          <div className='zcall_group_button'>
            {vm.state.flagStartCall && <div className={flagMinimize ? 'zcall_button_minimize' : 'zcall_button'} onClick={e => vm.changeFlagMic()}>
              <img className={flagMinimize ? 'zcall_btn_minimize zcall_btn_bg' : 'zcall_btn zcall_btn_bg'} alt='' src={changeColorSVG('./images/default/icons/mic_enable.svg')} style={(vm.state.flagMic) ? {display: 'block'} : {display: 'none'}} />
              <img className={flagMinimize ? 'zcall_btn_minimize zcall_btn_border' : 'zcall_btn zcall_btn_border'} alt='' src={changeColorSVG('./images/default/icons/mic_disable.svg')} style={(vm.state.flagMic) ? {display: 'none'} : {display: 'block'}}/>
            </div>}
            {/*(vm.state.flagStartCall && typeCall === 1) && <div className={flagMinimize ? 'zcall_button_minimize' : 'zcall_button'} onClick={e => vm.changeFlagCamera()}>
              <img className={flagMinimize ? 'zcall_btn_minimize zcall_btn_border' : 'zcall_btn zcall_btn_border'} alt='' src={changeColorSVG('./images/default/icons/call_video_enable.svg')} style={(!vm.state.flagCamera) ? {display: 'block'} : {display: 'none'}}/>
              <img className={flagMinimize ? 'zcall_btn_minimize zcall_btn_bg' : 'zcall_btn zcall_btn_bg'} alt='' src={changeColorSVG('./images/default/icons/call_video_disable.svg')} style={(vm.state.flagCamera) ? {display: 'block'} : {display: 'none'}} />
            </div>*/}

            {vm.state.flagStartCall && <div className={flagMinimize ? 'zcall_button_minimize' : 'zcall_button'} onClick={e => vm.onClickShareScreen()}>
              {(vm.state.flagShareScreen === true) && <img className={flagMinimize ? 'zcall_btn_minimize zcall_btn_sharescreen' : 'zcall_btn zcall_btn_sharescreen zcall_btn_active'} alt='' src={changeColorSVG('./images/default/icons/icon-sharescreen-white.svg')}/>}
              {(vm.state.flagShareScreen === false) && <img className={flagMinimize ? 'zcall_btn_minimize zcall_btn_sharescreen' : 'zcall_btn zcall_btn_sharescreen'} alt='' src={changeColorSVG('./images/default/icons/icon-sharescreen.svg')}/>}
            </div>}

            {vm.state.flagStartCall && <div className={flagMinimize ? 'zcall_button_minimize' : 'zcall_button'} onClick={e => vm.onClickFullScreen()}>
              <img className={flagMinimize ? 'zcall_btn_minimize zcall_btn_sharescreen' : 'zcall_btn zcall_btn_sharescreen'} alt='' src={changeColorSVG('./images/default/icons/icon-fullscreen.svg')}/>    
            </div>}

            {vm.state.flagStartCall && <div className={flagMinimize ? 'zcall_button_minimize' : 'zcall_button'} onClick={e => vm.onClickRecord()}>
              {(vm.state.isRecording === true) && <img className={flagMinimize ? 'zcall_btn_minimize zcall_btn_sharescreen' : 'zcall_btn zcall_btn_sharescreen zcall_btn_active'} alt='' src={changeColorSVG('./images/default/icons/icon-record.svg')}/>}
              {(vm.state.isRecording === false) && <img className={flagMinimize ? 'zcall_btn_minimize zcall_btn_sharescreen' : 'zcall_btn zcall_btn_sharescreen'} alt='' src={changeColorSVG('./images/default/icons/icon-record.svg')}/>}
            </div>}

            <div className={flagMinimize ? 'zcall_button_minimize' : 'zcall_button'} >
              <img className={flagMinimize ? 'zcall_cancel_minimize' : 'zcall_cancel'}  alt='' src={changeColorSVG('./images/default/icons/cancelcall.png')} onClick={e => {
                e.stopPropagation();
                vm.onClickStopCall();
              }}  />
            </div>

          </div>
        </div>}

        <div className='device-setting-icon icon-settings' onClick={(e) => vm.showDeviceSetting()}></div>

        {vm.state.flagShowSetting && <div className='device-setting'>
          <img className='device-setting-close' alt='' src={changeColorSVG('./images/default/icons/icon-close.png')} onClick={e => vm.onClickCloseSetting()}/>
          <div className='device-setting-row'>
            <div className='device-setting-label'>Audio Input</div>
            <label className="device-select-box" >
              <select value={vm.state.audioinputDefault} onChange={vm.changeDeviceAudioInput}>
                {vm.state.audioinput.map(deviceInfo => <option key={deviceInfo.value} value={deviceInfo.value}>{deviceInfo.text}</option>)}
              </select>
            </label>
          </div>
          <div className='device-setting-row'>
            <div className='device-setting-label'>Audio Output</div>
            <label className="device-select-box" >
              <select className='device-setting-select' value={vm.state.audiooutputDefault} onChange={vm.changeDeviceAudioOutput}>
                {vm.state.audiooutput.map(deviceInfo => <option key={deviceInfo.value} value={deviceInfo.value}>{deviceInfo.text}</option>)}
              </select>
            </label>
          </div>
        </div>}
      </div>

      {vm.state.showCallTrouble &&
        <div className='call-showdebug'>
          <div className='item-left'>
            <div className='item-title'>Stream Info</div>
            <div className='item-title'>Local Stream</div>
            <div className='item-title'>Remote Stream</div>
          </div>
          <div className='item-left'>
            <div className='item-title'>Bandwidth Speed</div>
            <div className='item-content'>{rxaget(vm.state.localStream, 'bandwidthSpeed', '')}</div>
            <div className='item-content'>{rxaget(vm.state.remoteStream, 'bandwidthSpeed', '')}</div>
          </div>
          <div className='item-left'>
            <div className='item-title'>STUN/TURN?</div>
            <div className='item-content'>{rxaget(vm.state.localStream, 'localIceType', '')}</div>
            <div className='item-content'>{rxaget(vm.state.remoteStream, 'remoteIceType', '')}</div>
          </div>
          <div className='item-left'>
            <div className='item-title'>Codecs</div>
            <div className='item-content'>{rxaget(vm.state.localStream, 'codecsSend', '')}</div>
            <div className='item-content'>{rxaget(vm.state.remoteStream, 'codecsRecv', '')}</div>
          </div>
          <div className='item-left'>
            <div className='item-title'>Encryption</div>
            <div className='item-content'>{rxaget(vm.state.localStream, 'encryptedAs', '')}</div>
            <div className='item-content'>{rxaget(vm.state.remoteStream, 'encryptedAs', '')}</div>
          </div>
          <div className='item-left'>
            <div className='item-title'>IP Address</div>
            <div className='item-content'>{rxaget(vm.state.localStream, 'externalIPAddressLocal', '')}</div>
            <div className='item-content'>{rxaget(vm.state.remoteStream, 'externalIPAddressRemote', '')}</div>
          </div>
          <div className='item-left'>
            <div className='item-title'>Resolutions</div>
            <div className='item-content'>{rxaget(vm.state.localStream, 'videoResolutionsForSenders', '')}</div>
            <div className='item-content'>{rxaget(vm.state.remoteStream, 'videoResolutionsForReceivers', '')}</div>
          </div>
          <div className='item-left'>
            <div className='item-title'>Data</div>
            <div className='item-content'>{rxaget(vm.state.localStream, 'totalDataForSenders', '')}</div>
            <div className='item-content'>{rxaget(vm.state.remoteStream, 'totalDataForReceivers', '')}</div>
          </div>
          <div className='item-left'>
            <div className='item-title'>Latency</div>
            <div className='item-content'>{rxaget(vm.state.localStream, 'audiolatency', '')}</div>
            <div className='item-content'>{rxaget(vm.state.remoteStream, 'audiolatency', '')}</div>
          </div>
          <div className='item-left'>
            <div className='item-title'>PacketsLost</div>
            <div className='item-content'>{rxaget(vm.state.localStream, 'audiopacketsLost', '')}</div>
            <div className='item-content'>{rxaget(vm.state.remoteStream, 'audiopacketsLost', '')}</div>
          </div>

        </div>
      }

      {vm.state.isRecording && 
        <div className='recording-indicator'>
          <div className='recording-dot'></div>
          <span>Recording</span>
        </div>
      }

    </div>
    
  </div>
}